export const UNLIMITED_PACKAGE_LIMIT = 999999999
